export default __webpack_public_path__ + "static/media/ember.b76abce7.svg";